import HttpFile from './HttpFile';

export default function install(Vue) {
  const file = new HttpFile(Vue.http);
  const fileX = new HttpFile(Vue.httpX);

  Object.defineProperty(Vue.prototype, '$file', {
    get() {
      return file;
    },
  });

  Object.defineProperty(Vue.prototype, '$fileX', {
    get() {
      return fileX;
    },
  });
}
